<template>
  <!-- <ScreenAdapter> -->
  <div class="fff">
    <Header />
    <Aside></Aside>
    <div class="container">
      <div class="accept-content bg" v-if="cjjyData&&cjjyData.length>0">
        <div class="content-header" ref="108">
          <div class="text">成就经验</div>
        </div>
        <div class="content-box">
          <div class="item" @click="jumpDetail(item)" v-for="item,index in cjjyData.slice(0,1)" :key="index">
            <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>
      </div>

      <div class="pioneer-content" v-if="xzzzData&&xzzzData.length>0">
        <div class="content-header" ref="213">
          <div class="text">性质宗旨</div>
        </div>
        <div class="content-box">
          <div class="cover-item" v-for="item,index in xzzzData.slice(0,2)" :key="index" @click="jumpDetail(item)">
            <div class="thumb-image">
              <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover;`">

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="accept-content zdsx" v-if="zdsxData&&zdsxData.length>0">
        <div class="content-header" ref="110">
          <div class="text">指导思想</div>
        </div>
        <div class="content-box">
          <div class="item" @click="jumpDetail(item)" v-for="item,index in zdsxData.slice(0,1)" :key="index">
            <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>
      </div>

      <div class="history-content" v-if="lnmbData&&lnmbData.length>0">
        <div class="content-header" ref="214">
          <div class="text">理念目标</div>
        </div>
        <div class="content-box">
          <div class="swiper">
            <swiper :options="swiperOption2">
              <swiper-slide v-for="item,index in lnmbData" :key="index">
                <div class="cover" :style="`background:url(${item.photo}) no-repeat center/cover;`" @click="jumpDetail(item)"></div>
              </swiper-slide>
            </swiper>
            <template v-if="lnmbData&&lnmbData.length>3">
              <div class="b swiper-pagination" slot="pagination"></div>
              <div class="b swiper-button-next">
              </div>
              <div class="b swiper-button-prev">
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="expand-content" ref="215" v-if="dzdgData && dzdgData.length > 0">
        <div class="content-header">
          <div class="text">党章党规</div>
        </div>
        <div class="content-box">
          <div class="expand-bg">
            <div class="expand-content">
              <div class="swiper-content">
                <swiper :options="expandSwiperOption">
                  <swiper-slide v-for="item in dzdgData.slice(0,-3)" :key="item.id" :data-kcid="item.id" :data-kcName="item.name">
                    <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`" :key="item.id" :data-kcid="item.id" :data-kcName="item.name"></div>
                  </swiper-slide>
                </swiper>
                <div class="swiper-pagination expand"></div>
                <div class="swiper-button-next expand" v-text="'>'"></div>
                <div class="swiper-button-prev expand" v-text="'<'"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-box expand" v-if="dzdgData&&dzdgData.length>0">
        <div class="cover-item" v-for="item,index in dzdgData.slice(-3)" :key="index" @click="jumpDetail(item)">
          <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
        </div>
      </div>

      <div class="value-content" v-if="dfdjData&&dfdjData.length>0">
        <div class="content-header" ref="216">
          <div class="text">党风党纪</div>
        </div>
        <div class="content-box">
          <div class="content-item" v-for="(item,index) in dfdjData.slice(0,2)" :key="index" @click="jumpDetail(item)">
            <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
          <div class="flex-hide"></div>
        </div>
      </div>

      <div class="pioneer-content" v-if="zzzdData&&zzzdData.length>0">
        <div class="content-header" ref="218">
          <div class="text">组织制度</div>
        </div>
        <div class="content-box">
          <div class="cover-item" v-for="item,index in zzzdData.slice(0,2)" :key="index" @click="jumpDetail(item)">
            <div class="thumb-image">
              <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover;`">

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="spirit-content" v-if="qlywData&&qlywData.length>0">
        <div class="content-header" ref="219">
          <div class="text">权利义务</div>
        </div>
        <div class="content-box">
          <div class="content-item" v-for="(item,index) in qlywData.slice(0,3)" :key="index" @click="jumpDetail(item)">
            <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
          <div class="flex-hide"></div>
        </div>
      </div>

      <div class="accept-content fzdygzxz" v-if="fzdygzxzData&&fzdygzxzData.length>0">
        <div class="content-header" ref="108">
          <div class="text">发展党员工作细则</div>
        </div>
        <div class="content-box">
          <div class="item" @click="jumpDetail(item)" v-for="item,index in fzdygzxzData.slice(0,1)" :key="index">
            <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>
      </div>

      <div class="origin-content" v-if="xsddxsdyData&&xsddxsdyData.length>0">
        <div class="content-header" ref="155">
          <div class="text">新时代大学生党员</div>
        </div>
        <div class="content-box">
          <div class="item" @click="jumpDetail(item)" v-for="item,index in xsddxsdyData.slice(0,2)" :key="index">
            <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>
      </div>

    </div>
    <Footer />
  </div>

  <!-- </ScreenAdapter> -->
</template>

<script>
import Header from "@/components/Custom/Party/Header"
import Footer from "@/components/Custom/Party/Footer"
// import ScreenAdapter from "@/components/ScreenAdapter"
import services from '@/config/services'
import utils from "../../../../config/utils"
import Aside from "../../../../components/Custom/Party/Aside.vue"
export default {
  data () {
    let that = this
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      swiperOption2: {
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        },
        dynamicBullets: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 41,
        pagination: {
          el: ".b.swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".b.swiper-button-next",
          prevEl: ".b.swiper-button-prev",
        },
        // loop: true,
      },
      expandSwiperOption: {
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        autoplay: {
          delay: 18000,
          disableOnInteraction: false
        },
        coverflowEffect: {
          rotate: 70,
          stretch: 200,
          depth: 480,
          modifier: 1,
          slideShadows: false,
        },
        preventClicksPropagation: false,
        navigation: {
          // 前进后退按钮 ,不同版本配置方式不同
          nextEl: `.swiper-button-next.expand`,
          prevEl: `.swiper-button-prev.expand`,
        },
        pagination: {
          el: `.swiper-pagination.expand`,
        },
        on: {
          click: function (v) {
            let id = v.target.getAttribute("data-kcid");
            if (id) {
              window.open(`/center/${that.school_code}/custom/party/detail?id=${id}&key=edu`, "_blank")
            }

          },
        },
      },

      cjjyData: [],
      xzzzData: [],
      zdsxData: [],
      lnmbData: [],
      dzdgData: [],
      dfdjData: [],
      zzzdData: [],
      qlywData: [],
      fzdygzxzData: [],
      xsddxsdyData: [],
    }
  },
  async mounted () {
    await this.getListData()
    await this.jumpPosition()
  },
  methods: {
    // 跳转到课程详情
    jumpDetail (item, key) {
      window.open(`/center/${this.school_code}/custom/party/detail?id=${item.id}&key=edu`, "_blank")
    },
    // 锚点定位
    jumpPosition () {
      let that = this
      let position = that.$route.query.id
      if (position) {
        that.$nextTick(() => {
          let topVal = this.$refs[position].getBoundingClientRect().top
          document.body.scrollTop = topVal - 100
        })
      }
    },

    async getListData () {
      await services.getCourseList({ category_id: 212, size: 1, school_code: this.school_code }).then(res => {
        this.cjjyData = res.data.items
      })
      await services.getCourseList({ category_id: 213, size: 2, school_code: this.school_code }).then(res => {
        this.xzzzData = res.data.items
      })
      await services.getCourseList({ category_id: 240, size: 1, school_code: this.school_code }).then(res => {
        this.zdsxData = res.data.items
      })
      await services.getCourseList({ category_id: 214, size: 100, school_code: this.school_code }).then(res => {
        this.lnmbData = res.data.items
      })
      await services.getCourseList({ category_id: 215, size: 100, school_code: this.school_code }).then(res => {
        this.dzdgData = res.data.items
      })
      await services.getCourseList({ category_id: 216, size: 2, school_code: this.school_code }).then(res => {
        this.dfdjData = res.data.items
      })
      await services.getCourseList({ category_id: 218, size: 2, school_code: this.school_code }).then(res => {
        this.zzzdData = res.data.items
      })
      await services.getCourseList({ category_id: 219, size: 3, school_code: this.school_code }).then(res => {
        this.qlywData = res.data.items
      })
      await services.getCourseList({ category_id: 220, size: 1, school_code: this.school_code }).then(res => {
        this.fzdygzxzData = res.data.items
      })
      await services.getCourseList({ category_id: 221, size: 2, school_code: this.school_code }).then(res => {
        this.xsddxsdyData = res.data.items
      })
    },
  },
  components: {
    Header,
    Footer,
    Aside,
    // ScreenAdapter
  }
}
</script>

<style  lang="less" scoped>
* {
    font-family: Microsoft YaHei;
}
.container {
    width: 1200px;
    margin: 0 auto;
    padding: 0 0 50px;
    .c-img {
        width: 100%;
        height: 100%;
        transition: all 0.7s;
    }
    .content-header {
        width: 100%;
        height: 25px;
        position: relative;
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url('../../../../assets/custom/party/index/list-title.png')
            no-repeat center / cover;
        .text {
            font-size: 42px;
            font-weight: bold;
            background: linear-gradient(180deg, #b70000 70%, #ffcba5 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
    .content-box {
        position: relative;
        z-index: 10;
    }
    .accept-content {
        position: relative;
        top: 35px;
        padding: 20px 0 0;
        &.bg::before {
            content: '';
            display: inline-block;
            position: absolute;
            width: 100vw;
            background: url('../../../../assets/hzvtc/list/footer-bg.png')
                no-repeat center/cover;
            height: 1340px;
            top: -38px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1;
        }
        .content-box {
            width: 100%;
            height: 730px;
            background: url('../../../../assets/hzvtc/list/vita-b-news.png')
                no-repeat center/cover;
            position: relative;
            margin-top: -24px;
            .item {
                cursor: pointer;
                width: 817px;
                height: 459px;
                box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                overflow: hidden;
                .c-img {
                    width: 100%;
                    height: 100%;
                    transition: all 0.7s;
                }
                &:hover {
                    .c-img {
                        transform: scale(1.2);
                    }
                }
            }
        }
        &.zdsx {
            &::before {
                content: '';
                display: inline-block;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                top: 135px;
                width: 100vw;
                height: 650px;
                background: url('../../../../assets/hzvtc/list/profession-bg-c.png')
                    no-repeat center/cover;
            }
            .content-header {
                margin: 20px 0 0;
            }
        }
        &.fzdygzxz {
            .content-header {
                &::before,
                &::after {
                    width: 350px;
                }
            }
        }
    }

    .pioneer-content {
        margin-bottom: 40px;
        position: relative;

        .content-header {
            margin: 45px 0 33px;
        }
        .content-box {
            display: flex;
            justify-content: space-between;
            .cover-item {
                width: 580px;
                height: 387px;
                background: #b61e2a;
                border: 1px solid #e8d9c5;
                padding: 30px 0;
                cursor: pointer;
                .thumb-image {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    &:hover {
                        .c-img {
                            transform: scale(1.2);
                        }
                    }
                }
            }
        }
    }

    .expand-content {
        .content-header {
            margin: 40px 0 0;
        }
        .content-box {
            .swiper-slide {
                width: 740px !important;
                height: 416px !important;
                .cover {
                    width: 100%;
                    height: 100%;
                }
            }

            ::v-deep .swiper-pagination {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                bottom: -32px;
                left: 50%;
                transform: translateX(-50%);
            }
            ::v-deep .swiper-pagination-bullet {
                width: 7px;
                height: 7px;
                background: #b61e2a;
                border: 1px solid #ffffff;
                opacity: 0.5;
                border-radius: 50%;
                display: block;
                transition: all 0.3s;
                margin-right: 4px;
            }

            ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
                width: 13px;
                height: 7px;
                background: #b61e2a;
                border: 1px solid #ffffff;
                border-radius: 3px;
                opacity: 1;
                margin-right: 7px;
            }
        }
    }

    .expand-bg {
        background-position: center;
        background-size: cover;
        padding: 48px 0 38px;
        .expand-content {
            width: 1200px;
            margin: 0 auto;
            .swiper-content {
                position: relative;
                width: 100%;
                height: 465px;
                display: flex;
                align-items: center;
                .swiper-container {
                    height: 100%;
                    .swiper-wrapper {
                        .swiper-slide {
                            width: 740px;
                            height: 416px;
                            background: #fff;
                            background-size: 100% auto;
                            background-position: center;
                            cursor: pointer;
                            overflow: hidden;
                            .c-img {
                                width: 100%;
                                height: 100%;
                                transition: all 0.7s;
                            }
                            &.swiper-slide-active {
                                -webkit-transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                -moz-transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                -o-transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                -ms-transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                border: 2px solid red;
                                &:hover {
                                    .c-img {
                                        transform: scale(1.2);
                                    }
                                }
                            }
                        }
                    }
                }
                /deep/ .swiper-pagination {
                    bottom: 10px;
                    width: 100%;
                    .swiper-pagination-bullet {
                        width: 10px;
                        height: 10px;
                        background: #cdb29f;
                        border-radius: 50%;
                        margin: 0 6px;
                    }
                    .swiper-pagination-bullet.swiper-pagination-bullet-active {
                        width: 10px;
                        height: 10px;
                        background: #dd3639;
                        border-radius: 50%;
                    }
                }
                .swiper-button-next,
                .swiper-button-prev {
                    flex-shrink: 0;
                    background-size: cover;
                    background: #000;
                    z-index: 100;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    cursor: pointer;
                    text-align: center;
                    line-height: 44px;
                    width: 42px;
                    height: 44px;
                    color: #ffffff;
                    font-size: 22px;
                    font-family: fangsong;
                    font-weight: bold;
                    justify-content: center;
                }
                .swiper-button-prev {
                    left: 200px;

                    background: rgba(0, 0, 0, 0.37);
                    border-radius: 22px 0px 0px 22px;
                }
                .swiper-button-next {
                    right: 200px;

                    background: rgba(0, 0, 0, 0.37);
                    border-radius: 0px 22px 22px 0px;
                }
            }
        }
    }
    .expand {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        .cover-item {
            cursor: pointer;
            width: 380px;
            height: 214px;
            margin-bottom: 20px;
            overflow: hidden;
            &:hover {
                .c-img {
                    transform: scale(1.2);
                }
            }
        }
        .flex-hide {
            flex: 0 0 380px;
            visibility: hidden;
            display: block;
        }
    }

    .history-content {
        margin: 50px 0 36px;
        .content-header {
            margin-bottom: 35px;
        }
        .content-box {
            .swiper {
                position: relative;
                .swiper-slide {
                    width: 380px;
                    height: 214px;
                    overflow: hidden;
                    &:hover {
                        .cover {
                            transform: scale(1.2);
                        }
                    }
                }
                .cover {
                    width: calc(100%);
                    height: 100%;
                    cursor: pointer;
                    transition: all 0.7s;
                }
                ::v-deep .swiper-pagination {
                    margin-top: 24px;
                    display: flex;
                    justify-content: center;
                }
                ::v-deep .swiper-pagination-bullet {
                    width: 10px;
                    height: 10px;
                    background: #cdb29f;
                    border-radius: 50%;
                    display: block;
                    cursor: pointer;
                    &:not(:last-child) {
                        margin-right: 15px;
                    }
                }
                ::v-deep
                    .swiper-pagination-bullet.swiper-pagination-bullet-active {
                    background: #dd3639;
                }
                ::v-deep .swiper-button-next,
                ::v-deep .swiper-button-prev {
                    width: 17px;
                    height: 32px;
                    cursor: pointer;
                    display: block;
                }
                ::v-deep .swiper-wrapper {
                    position: unset !important;
                }
                ::v-deep .swiper-button-prev {
                    background: url('../../../../assets/hzvtc/list/swiper-prev.png')
                        no-repeat center/cover;
                    position: absolute;
                    top: 41%;
                    left: -24px;
                }

                ::v-deep .swiper-button-next {
                    background: url('../../../../assets/hzvtc/list/swiper-next.png')
                        no-repeat center/cover;
                    position: absolute;
                    top: 41%;
                    right: -24px;
                }
            }
        }
    }

    .value-content {
        position: relative;
        padding: 74px 0 18px;
        background: #ffe093;
        height: 547px;
        z-index: 10;
        margin: 50px 0 0;
        .content-box {
            position: relative;
            z-index: 10;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }
        &::before {
            content: '';
            display: inline-block;
            width: 100vw;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            height: 452px;
            position: absolute;
            background: url('../../../../assets/hzvtc/list/feature-bg.png')
                no-repeat center/cover;
        }
        .content-header {
            margin-bottom: 62px;
            font-weight: bold;
            .text {
                color: #fedfa8;
                background: unset;
                -webkit-text-fill-color: unset;
            }
        }

        &::after {
            content: '';
            display: inline-block;
            width: 100%;
            height: 510px;
            position: absolute;
            top: 18px;
            background: url('../../../../assets/hzvtc/list/feature-list-bg.png')
                no-repeat center/cover;
        }
        .content-box {
            justify-content: space-between;
            padding: 0 40px;
            .content-item {
                width: 545px;
                height: 307px;
                cursor: pointer;
                overflow: hidden;
                &:hover {
                    .c-img {
                        transform: scale(1.2);
                    }
                }
            }
        }
    }

    .spirit-content {
        .content-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            .content-item {
                cursor: pointer;
                width: 380px;
                height: 214px;
                overflow: hidden;
                margin-bottom: 30px;
                &:hover {
                    .c-img {
                        transform: scale(1.2);
                    }
                }
            }
            .flex-hide {
                flex: 0 0 380px;
                visibility: hidden;
                display: block;
            }
        }
        .content-header {
            margin: 50px 0 40px;
            &::before,
            &::after {
                width: 450px;
            }
        }
    }

    .origin-content {
        .content-header {
            margin: 47px 0 40px;
            &::before,
            &::after {
                width: 350px;
            }
        }
        .content-box {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .item {
                width: 578px;
                height: 325px;
                cursor: pointer;
                margin-bottom: 24px;
                overflow: hidden;
                &:hover {
                    .c-img {
                        transform: scale(1.2);
                    }
                }
            }
        }
    }
}
.fff {
    background: #fff;
}
</style>


